import script from "./WeekdayPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeekdayPicker.vue?vue&type=script&lang=ts&setup=true"

import "./WeekdayPicker.vue?vue&type=style&index=0&id=1dee3c80&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dee3c80"]])

export default __exports__